import {
  Box_default
} from "./chunk-JULFPWYQ.js";
import "./chunk-YM5EU6E7.js";
import "./chunk-EL3UO5XZ.js";
import "./chunk-PRPF77W2.js";
import "./chunk-RZUAS4O2.js";
import "./chunk-LXPIB7J4.js";
import "./chunk-KV7LZDKO.js";
import "./chunk-PE5RM2P6.js";
import "./chunk-OPCEO46S.js";
import "./chunk-IR5R5TKS.js";
import "./chunk-KJIRP3BF.js";
import "./chunk-J43GMYXM.js";

// dep:@mui_material_Box
var mui_material_Box_default = Box_default;
export {
  mui_material_Box_default as default
};
//# sourceMappingURL=@mui_material_Box.js.map
